import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        "\n  padding: 16px;\n  background-color: ",
        ";\n  border-radius: 6px;\n\n  & textarea::placeholder {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _tagged_template_literal([
        "\n  margin-bottom: 4px;\n  color: ",
        ";\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 22px; /* 157.143% */\n  letter-spacing: -0.14px;\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  margin-bottom: 16px;\n\n  span {\n    color: ",
        ";\n    font-size: 18px;\n    font-weight: 600;\n    line-height: 26px; /* 144.444% */\n  }\n\n  strong {\n    color: ",
        ";\n  }\n\n  small {\n    display: inline-flex;\n    margin-left: 8px;\n    align-items: center;\n    color: ",
        ";\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 22px; /* 157.143% */\n    letter-spacing: -0.14px;\n  }\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Divider, Rating, styled as muiStyled } from "@mui/material";
import BigNumber from "bignumber.js";
import { forwardRef, useMemo } from "react";
import styled, { useTheme } from "styled-components";
import Icon from "../icon/Icon";
import { Sizes, Star } from "../icon/IconList";
const ReviewSectionCardWrapper = styled.div.withConfig({
    componentId: "sc-587a3800-0"
})(_templateObject(), (props)=>props.theme.new.colors.white, (props)=>props.theme.new.colors.sol_gray_300);
const ReviewSectionTitle = styled.h2.withConfig({
    componentId: "sc-587a3800-1"
})(_templateObject1(), (props)=>props.theme.new.colors[props.color]);
export const ReviewSectionCard = (param)=>{
    let { children , title , titleColor ="sol_blue_500"  } = param;
    return /*#__PURE__*/ _jsxs(ReviewSectionCardWrapper, {
        children: [
            /*#__PURE__*/ _jsx(ReviewSectionTitle, {
                color: titleColor,
                children: title
            }),
            children
        ]
    });
};
const ReviewTitleWrapper = styled.h3.withConfig({
    componentId: "sc-587a3800-2"
})(_templateObject2(), (props)=>props.theme.new.colors.sol_blue_900, (param)=>{
    let { theme  } = param;
    return theme.new.colors.sol_indigo_500;
}, (props)=>props.theme.new.colors.sol_gray_300);
export const ReviewTitle = (param)=>{
    let { children , smallSuffix  } = param;
    return /*#__PURE__*/ _jsxs(ReviewTitleWrapper, {
        children: [
            /*#__PURE__*/ _jsx("span", {
                children: children
            }),
            !!smallSuffix && /*#__PURE__*/ _jsx("small", {
                children: smallSuffix
            })
        ]
    });
};
export const ReviewFormDivider = styled(Divider).withConfig({
    componentId: "sc-587a3800-3"
})({
    "&.MuiDivider-root": {
        margin: "24px 0"
    }
});
const ReviewChipButtonWrapper = muiStyled(Button)((param)=>{
    let { theme , selected  } = param;
    const { typography: { pxToRem: tpr , ...typo }  } = theme;
    return {
        "&.MuiButton-outlined": {
            padding: tpr(12).concat(" ", tpr(16)),
            backgroundColor: selected ? theme.palette.indigo[50] : theme.palette.blackAndWhite.white,
            borderColor: selected ? theme.palette.indigo[200] : theme.palette.grey[100],
            color: theme.palette[selected ? "indigo" : "grey"][500],
            ...typo.semibold16,
            "&:hover": {
                backgroundColor: theme.palette.indigo[50]
            }
        }
    };
});
export const ReviewChipButton = /*#__PURE__*/ forwardRef((param, ref)=>{
    let { children , variant ="outlined" , label , alignStart , ...props } = param;
    return /*#__PURE__*/ _jsx(ReviewChipButtonWrapper, {
        ref: ref,
        variant: variant,
        ...props,
        sx: {
            ...alignStart ? {
                justifyContent: "flex-start"
            } : {
                "&.MuiButton-outlined": (theme)=>({
                        [theme.breakpoints.down("sm")]: {
                            px: 0
                        }
                    })
            }
        },
        children: children || label
    });
});
const StyledRating = styled(Rating).withConfig({
    componentId: "sc-587a3800-4"
})((param)=>{
    let { theme  } = param;
    return {
        "& .MuiRating-icon": {
            transition: "color 0.2s"
        },
        "& .MuiRating-decimal > span:has(.MuiRating-iconFilled)": {
            zIndex: 1
        },
        "&:hover": {
            "& .MuiRating-iconFilled": {
                color: theme.new.colors.sol_yellow_200
            },
            "& .MuiRating-iconEmpty": {
                color: theme.new.colors.sol_gray_100
            }
        }
    };
});
export const ProductRating = /*#__PURE__*/ forwardRef((param, ref)=>{
    let { precision =0.01 , readOnly =true , size =Sizes.large , value: _value , ...props } = param;
    const theme = useTheme();
    const { value  } = useMemo(()=>{
        let result = _value;
        if (_value) {
            const integer = BigNumber(_value).integerValue(BigNumber.ROUND_FLOOR);
            if (BigNumber(_value).comparedTo(integer) !== 0) {
                const decimal = BigNumber(_value).minus(integer);
                const calculated = decimal.multipliedBy(BigNumber(0.7)).plus(BigNumber(0.15));
                // console.log(integer.toNumber(), decimal.toNumber(), calculated.toNumber())
                result = calculated.plus(integer).toNumber();
            }
        }
        return {
            value: result
        };
    }, [
        _value
    ]);
    return /*#__PURE__*/ _jsx(StyledRating, {
        tabIndex: 0,
        ref: ref,
        icon: /*#__PURE__*/ _jsx(Icon, {
            icon: Star,
            size: size,
            color: theme.new.colors.sol_yellow_400
        }),
        emptyIcon: /*#__PURE__*/ _jsx(Icon, {
            icon: Star,
            size: size,
            color: theme.new.colors.sol_gray_100
        }),
        precision: precision,
        readOnly: readOnly,
        value: value,
        ...props
    });
});
